module.exports = __webpack_public_path__ + "img/foot-icon.7380e599.png";